module.exports = __webpack_public_path__ + "img/cash-coin.82a9fce6.svg";